<!-- ALERT -->
<p-toast></p-toast>

<!-- LOADING SCREEN-->
<div *ngIf="blocked" class="overlay">
    <img src="assets/layout/images/tovlogo.png" alt="Loading Icon" class="loading-image" />
    <span style="color: white; font-size: large;">Cargando ... </span>
</div>

<!-- MAIN COMPONENT-->
<div class="card">

    <!-- GO BACK -->
    <p-toolbar styleClass="p-mb-4">
        <ng-template pTemplate="left">
            <button pButton pRipple label="{{translations.lbl_go_Back}}" icon="pi pi-chevron-left"
                class="p-button-warning p-mr-2" (click)="goBack()"></button>
        </ng-template>
    </p-toolbar>

    <!-- FORM CONTENT -->
    <div class="p-grid">
        <div class="p-col-12 p-md-6">
            <p-panel>
                <div class="p-grid">
                    <!-- INPUT SELLER -->
                    <div class="p-col-12">
                        <div class="p-formgrid p-grid p-ai-center p-jc-between p-pt-1 p-py-1">
                            <div class="subTitle p-col-12 p-md-4">
                                <span>{{translations.lbl_vendor}}</span>
                            </div>
                            <div class="p-col-12 p-md-8">
                                <p-dropdown [options]="listSuppliers" [(ngModel)]="selectedSupplier" optionLabel="name"
                                    [showClear]="true" placeholder="{{translations.lbl_vendor}}"
                                    (onChange)="loadPurchOrdSup()"></p-dropdown>
                            </div>
                        </div>
                    </div>
                </div>
            </p-panel>
        </div>
    </div>


    <!-- MAIN TABLE -->
    <p-table #dt [value]="orderList" [exportFilename]="tableName"
        [columns]="[{ field: 'ordH.orderId', header: 'Solicitud de Material' },{ field: 'ordH.ordDate', header: 'Fecha Requerimiento' },
                    { field: 'stsDesc', header: 'Estatus' },{ field: 'storeDesc', header: 'Nombre' },{ field: 'currDesc', header: 'Moneda' }]" [rows]="10" [paginator]="true"
        [globalFilterFields]="['ordH.orderId','ordH.ordDate','stsDesc','storeDesc','currDesc']"
        [(selection)]="selectedPurchOrdSup" selectionMode="multiple" [rowHover]="true" dataKey="ordH.orderId"
        currentPageReportTemplate="{{translations.lbl_showing}} {first} {{translations.lbl_of}} {last} {{translations.lbl_records}}"
        [showCurrentPageReport]="true" responsive="true">

        <!-- CAPTION -->
        <ng-template pTemplate="caption">
            <div class="p-d-flex p-ai-left p-jc-between">
                <!-- MAIN TITLE-->
                <h5 class="p-md-6">{{translations.lbl_OR_vendor_quote}}</h5>
                <span class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                        placeholder="{{translations.lbl_search}}..." />
                </span>
            </div>

            <!-- OPTIONS -->
            <span class="p-input-icon-left">
                <button pButton pRipple pTooltip="{{translations.lbl_new}}" icon="pi pi-plus" class="p-mr-4 z-5"
                    (click)="createPurchOrdSup()"></button>

                <button type="button" pButton pRipple icon="pi pi-file-excel" (click)="exportExcel()"
                    class="p-button-success p-mr-2 z-5" pTooltip="XLS" tooltipPosition="bottom"></button>

                <button type="button" pButton pRipple icon="pi pi-file-pdf" (click)="exportPdf()"
                    class="p-button-warning p-mr-2" pTooltip="PDF" tooltipPosition="bottom"></button>

            </span>

        </ng-template>

        <ng-template pTemplate="header">
            <!-- Order -->
            <tr>
                <th pSortableColumn="ordH.orderId">{{translations.lbl_orders_request}}<p-sortIcon
                        field="ordH.orderId"></p-sortIcon>
                </th>
                <th pSortableColumn="ordH.ordDate">{{translations.lbl_req_Date}}<p-sortIcon
                        field="ordH.ordDate"></p-sortIcon>
                </th>
                <th pSortableColumn="stsDesc">{{translations.lbl_status}}<p-sortIcon field="stsDesc"></p-sortIcon></th>
                <th pSortableColumn="storeDesc">{{translations.lbl_name}}<p-sortIcon field="storeDesc"></p-sortIcon>
                </th>
                <th pSortableColumn="currDesc">{{translations.lbl_currency}}<p-sortIcon field="currDesc"></p-sortIcon>
                </th>
                <th pSortableColumn="ordH.language">{{translations.lbl_language}}<p-sortIcon
                        field="ordH.language"></p-sortIcon></th>
                <th>{{translations.lbl_options}}</th>
            </tr>
            <!-- Filter -->
            <tr>
                <th>
                    <p-columnFilter type="text" field="ordH.orderId"></p-columnFilter>
                </th>
                <th>
                    <p-columnFilter type="text" field="ordH.ordDate"></p-columnFilter>
                </th>
                <th>
                    <p-columnFilter field="stsDesc" matchMode="equals" [showMenu]="false">
                        <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                            <p-dropdown [ngModel]="value" [options]="statusList" (onChange)="filter($event.value)"
                                placeholder="{{translations.lbl_select}} {{translations.lbl_status}}"
                                [showClear]="true">
                                <ng-template let-option pTemplate="item">
                                    <span [class]="'customer-badge status-' + option.value">{{option.label}}</span>
                                </ng-template>
                            </p-dropdown>
                        </ng-template>
                    </p-columnFilter>
                </th>
                <th>
                    <p-columnFilter field="storeDesc" matchMode="equals" [showMenu]="false">
                        <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                            <p-dropdown [ngModel]="value" [options]="nameList" (onChange)="filter($event.value)"
                                placeholder="{{translations.lbl_select}} {{translations.lbl_name}}" [showClear]="true">
                                <ng-template let-option pTemplate="item">
                                    <span [class]="'customer-badge status-' + option.value">{{option.label}}</span>
                                </ng-template>
                            </p-dropdown>
                        </ng-template>
                    </p-columnFilter>
                </th>

                <th>
                    <p-columnFilter field="currDesc" matchMode="equals" [showMenu]="false">
                        <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                            <p-dropdown [ngModel]="value" [options]="currencyList" (onChange)="filter($event.value)"
                                placeholder="{{translations.lbl_select}} {{translations.lbl_currency}}"
                                [showClear]="true">
                                <ng-template let-option pTemplate="item">
                                    <span [class]="'customer-badge status-' + option.value">{{option.label}}</span>
                                </ng-template>
                            </p-dropdown>
                        </ng-template>
                    </p-columnFilter>
                </th>
                <th>
                    <p-columnFilter type="text" field="ordH.language"></p-columnFilter>
                </th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-ord>
            <tr [pSelectableRow]="ord">
                <td>{{ord?.ordH?.orderId || ' '}}</td>
                <td>{{ord?.ordH?.ordDate || ' '}}</td>
                <td>{{ord?.stsDesc || ' '}}</td>
                <td>{{ord?.storeDesc || ' '}}</td>
                <td>{{ord?.currDesc || ' '}}</td>
                <td>{{ord?.ordH?.language || ' '}}</td>

                <td>
                    <button pButton pRipple icon="pi pi-pencil" class="p-button-rounded p-button-warning p-mr-2"
                        *ngIf="ord.ordH.status!='C'" (click)="editPurchOrdSup(ord)"></button>
                    <button pButton pRipple icon="pi pi-search" class="p-button-rounded p-button-info p-mr-2"
                        *ngIf="ord.ordH.status=='C'" (click)="editPurchOrdSup(ord)"
                        pTooltip="{{translations.lbl_select}}"></button>
                    <button pButton pRipple icon="pi pi-trash" class="p-button-rounded p-button-danger"
                        (click)="deletePurchOrdSup(ord)" *ngIf="ord.ordH.status=='N'"></button>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="summary">
            <div class="p-d-flex p-ai-center p-jc-between">
                {{translations.lbl_total}} {{orderList ? orderList.length : 0 }}
                {{translations.lbl_records}}
            </div>
        </ng-template>
    </p-table>
</div>

<!-- CONFIRM DIALOG -->
<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>